export { ContentContainer } from './ContentContainer';

export type { ContentContainerProps } from './ContentContainer';
